import { animationFrame$ } from "../../../messages/xr/AnimationFrame";
import { camera } from "../camera";
import { Vector3, Vector4 } from "flavr-math";
import { localPlayerContainer } from "../../localplayer/LocalPlayerContainer";
import { now } from "../../../messages/timing";
import { LinearFilter, RepeatWrapping, ImageLoader, DefaultLoadingManager, Texture, RGBAFormat, LinearMipMapLinearFilter, Uniform, SRGBColorSpace, ClampToEdgeWrapping } from "three";
import NOISE_TEXTURE_SRC from "../../../../assets/img/perlin-512.png";
import GRID_TEXTURE_SRC from "../../../../assets/img/grid.png";
// Gizmo textures
import TRANSLATE_TEXTURE_SRC from "../../../../assets/img/translate.png";
import ROTATE_TEXTURE_SRC from "../../../../assets/img/rotate.png";
import SCALE_TEXTURE_SRC from "../../../../assets/img/scale.png";
import TRANSFORM_GLOBAL_TEXTURE_SRC from "../../../../assets/img/global.png";
import TRANSFORM_LOCAL_TEXTURE_SRC from "../../../../assets/img/local.png";
import TRANSFORM_RESET_TEXTURE_SRC from "../../../../assets/img/reset.png";
// Drop indicator textures
import DROP_TEXTURE_SRC from "../../../../assets/img/drop.png";
// we can't use the textureLoaderService here, because it imports from
// "three/examples/jsm/loaders/DDSLoader" which can't be resolved in the test environment.
// import { textureLoaderService } from "../services/TextureLoaderService";
export const globalCameraWorld = new Vector4();
const tempCameraWorldPosition = new Vector3();
const imageLoader = new ImageLoader(DefaultLoadingManager);
imageLoader.setCrossOrigin("anonymous");
const NOISE_TEXTURE = new Texture();
imageLoader.load(NOISE_TEXTURE_SRC, (image) => {
    NOISE_TEXTURE.image = image;
    NOISE_TEXTURE.format = RGBAFormat;
    NOISE_TEXTURE.magFilter = LinearFilter;
    NOISE_TEXTURE.wrapS = RepeatWrapping;
    NOISE_TEXTURE.wrapT = RepeatWrapping;
    NOISE_TEXTURE.minFilter = LinearMipMapLinearFilter;
    NOISE_TEXTURE.needsUpdate = true;
});
const GRID_TEXTURE = new Texture();
imageLoader.load(GRID_TEXTURE_SRC, (image) => {
    GRID_TEXTURE.image = image;
    GRID_TEXTURE.format = RGBAFormat;
    GRID_TEXTURE.magFilter = LinearFilter;
    GRID_TEXTURE.wrapS = RepeatWrapping;
    GRID_TEXTURE.wrapT = RepeatWrapping;
    GRID_TEXTURE.minFilter = LinearMipMapLinearFilter;
    GRID_TEXTURE.needsUpdate = true;
});
const TRANSLATE_TEXTURE = new Texture();
imageLoader.load(TRANSLATE_TEXTURE_SRC, (image) => {
    TRANSLATE_TEXTURE.image = image;
    TRANSLATE_TEXTURE.format = RGBAFormat;
    TRANSLATE_TEXTURE.minFilter = LinearFilter;
    TRANSLATE_TEXTURE.magFilter = LinearFilter;
    TRANSLATE_TEXTURE.wrapS = ClampToEdgeWrapping;
    TRANSLATE_TEXTURE.wrapT = ClampToEdgeWrapping;
    TRANSLATE_TEXTURE.colorSpace = SRGBColorSpace;
    TRANSLATE_TEXTURE.needsUpdate = true;
});
const ROTATE_TEXTURE = new Texture();
imageLoader.load(ROTATE_TEXTURE_SRC, (image) => {
    ROTATE_TEXTURE.image = image;
    ROTATE_TEXTURE.format = RGBAFormat;
    ROTATE_TEXTURE.minFilter = LinearFilter;
    ROTATE_TEXTURE.magFilter = LinearFilter;
    ROTATE_TEXTURE.wrapS = ClampToEdgeWrapping;
    ROTATE_TEXTURE.wrapT = ClampToEdgeWrapping;
    ROTATE_TEXTURE.colorSpace = SRGBColorSpace;
    ROTATE_TEXTURE.needsUpdate = true;
});
const SCALE_TEXTURE = new Texture();
imageLoader.load(SCALE_TEXTURE_SRC, (image) => {
    SCALE_TEXTURE.image = image;
    SCALE_TEXTURE.format = RGBAFormat;
    SCALE_TEXTURE.minFilter = LinearFilter;
    SCALE_TEXTURE.magFilter = LinearFilter;
    SCALE_TEXTURE.wrapS = ClampToEdgeWrapping;
    SCALE_TEXTURE.wrapT = ClampToEdgeWrapping;
    SCALE_TEXTURE.colorSpace = SRGBColorSpace;
    SCALE_TEXTURE.needsUpdate = true;
});
const TRANSFORM_GLOBAL_TEXTURE = new Texture();
imageLoader.load(TRANSFORM_GLOBAL_TEXTURE_SRC, (image) => {
    TRANSFORM_GLOBAL_TEXTURE.image = image;
    TRANSFORM_GLOBAL_TEXTURE.format = RGBAFormat;
    TRANSFORM_GLOBAL_TEXTURE.minFilter = LinearFilter;
    TRANSFORM_GLOBAL_TEXTURE.magFilter = LinearFilter;
    TRANSFORM_GLOBAL_TEXTURE.wrapS = ClampToEdgeWrapping;
    TRANSFORM_GLOBAL_TEXTURE.wrapT = ClampToEdgeWrapping;
    TRANSFORM_GLOBAL_TEXTURE.colorSpace = SRGBColorSpace;
    TRANSFORM_GLOBAL_TEXTURE.needsUpdate = true;
});
const TRANSFORM_LOCAL_TEXTURE = new Texture();
imageLoader.load(TRANSFORM_LOCAL_TEXTURE_SRC, (image) => {
    TRANSFORM_LOCAL_TEXTURE.image = image;
    TRANSFORM_LOCAL_TEXTURE.format = RGBAFormat;
    TRANSFORM_LOCAL_TEXTURE.minFilter = LinearFilter;
    TRANSFORM_LOCAL_TEXTURE.magFilter = LinearFilter;
    TRANSFORM_LOCAL_TEXTURE.wrapS = ClampToEdgeWrapping;
    TRANSFORM_LOCAL_TEXTURE.wrapT = ClampToEdgeWrapping;
    TRANSFORM_LOCAL_TEXTURE.colorSpace = SRGBColorSpace;
    TRANSFORM_LOCAL_TEXTURE.needsUpdate = true;
});
const TRANSFORM_RESET_TEXTURE = new Texture();
imageLoader.load(TRANSFORM_RESET_TEXTURE_SRC, (image) => {
    TRANSFORM_RESET_TEXTURE.image = image;
    TRANSFORM_RESET_TEXTURE.format = RGBAFormat;
    TRANSFORM_RESET_TEXTURE.minFilter = LinearFilter;
    TRANSFORM_RESET_TEXTURE.magFilter = LinearFilter;
    TRANSFORM_RESET_TEXTURE.wrapS = ClampToEdgeWrapping;
    TRANSFORM_RESET_TEXTURE.wrapT = ClampToEdgeWrapping;
    TRANSFORM_RESET_TEXTURE.colorSpace = SRGBColorSpace;
    TRANSFORM_RESET_TEXTURE.needsUpdate = true;
});
/// Drop indicator textures ///
const DROP_TEXTURE = new Texture();
imageLoader.load(DROP_TEXTURE_SRC, (image) => {
    DROP_TEXTURE.image = image;
    DROP_TEXTURE.format = RGBAFormat;
    DROP_TEXTURE.minFilter = LinearFilter;
    DROP_TEXTURE.magFilter = LinearFilter;
    DROP_TEXTURE.wrapS = ClampToEdgeWrapping;
    DROP_TEXTURE.wrapT = ClampToEdgeWrapping;
    DROP_TEXTURE.colorSpace = SRGBColorSpace;
    DROP_TEXTURE.needsUpdate = true;
});
export const GLOBAL_UNIFORMS = {
    cameraCenterWorldPosition: new Uniform(new Vector3()),
    platformScale: new Uniform(1),
    time: new Uniform(0),
    noiseTexture: new Uniform(NOISE_TEXTURE),
    gridTexture: new Uniform(GRID_TEXTURE),
    translateTexture: TRANSLATE_TEXTURE,
    rotateTexture: ROTATE_TEXTURE,
    scaleTexture: SCALE_TEXTURE,
    transformGlobalTexture: TRANSFORM_GLOBAL_TEXTURE,
    transformLocalTexture: TRANSFORM_LOCAL_TEXTURE,
    transformResetTexture: TRANSFORM_RESET_TEXTURE,
    dropTexture: DROP_TEXTURE,
};
animationFrame$.onPreRender$.add(() => {
    tempCameraWorldPosition.setFromMatrixPosition(camera.perspectiveCam.matrixWorld);
    GLOBAL_UNIFORMS.cameraCenterWorldPosition.value.copy(tempCameraWorldPosition);
    GLOBAL_UNIFORMS.platformScale.value = localPlayerContainer.getPlatformScale();
    GLOBAL_UNIFORMS.time.value = now();
    globalCameraWorld.set(tempCameraWorldPosition.x, tempCameraWorldPosition.y, tempCameraWorldPosition.z, localPlayerContainer.getWorldScale());
});
